import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center"
}
const _hoisted_2 = { class: "bg-white p-5 rounded-lg shadow-lg" }
const _hoisted_3 = { class: "space-y-3" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex justify-end space-x-2 pt-2" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-lg font-bold mb-4" }, "Select Next Step", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedDate) = $event)),
              class: "w-full rounded border p-2 text-sm"
            }, null, 512), [
              [_vModelText, $data.selectedDate]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.selectedTime) = $event)),
                class: "w-full rounded border p-2 text-sm"
              }, null, 512), [
                [_vModelText, $data.selectedTime]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.selectedStatus) = $event)),
                class: "w-full rounded border p-2 text-sm"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Select status", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.interviewStatuses, (status) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: status,
                    value: status
                  }, _toDisplayString(status), 9, _hoisted_5))
                }), 128))
              ], 512), [
                [_vModelSelect, $data.selectedStatus]
              ])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.stepNote) = $event)),
              rows: "3",
              placeholder: "Step note (optional)",
              class: "w-full rounded border p-2 text-sm"
            }, null, 512), [
              [_vModelText, $data.stepNote]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.close && $options.close(...args))),
              class: "px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
            }, "Cancel"),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.confirmSelection && $options.confirmSelection(...args))),
              disabled: !$data.selectedStatus,
              class: "px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-300"
            }, " Confirm ", 8, _hoisted_7)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}